'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContextContent = require('../Context/ContextContent');

var _ContextContent2 = _interopRequireDefault(_ContextContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownContent = function (_Component) {
  _inherits(DropdownContent, _Component);

  function DropdownContent() {
    _classCallCheck(this, DropdownContent);

    return _possibleConstructorReturn(this, (DropdownContent.__proto__ || Object.getPrototypeOf(DropdownContent)).apply(this, arguments));
  }

  _createClass(DropdownContent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_ContextContent2.default, this.props);
    }
  }]);

  return DropdownContent;
}(_react.Component);

DropdownContent.propTypes = {
  /** Determines whether the separator below this context box should cut through the padding */
  hasFullSeparator: _propTypes2.default.bool,
  /** Set height for the content area, box will remain at this height */
  height: _propTypes2.default.string,
  /** Maximum height for the content area, exceeding this will make it scrollable */
  maxHeight: _propTypes2.default.string,
  /** Padding size applied to the content area */
  padding: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
  /** Horizontal padding size applied to the content area */
  paddingHorizontal: _propTypes2.default.oneOf(['none', 'small', 'large']),
  /** Vertical padding size applied to the content area */
  paddingVertical: _propTypes2.default.oneOf(['none', 'small', 'large'])
};
exports.default = DropdownContent;